var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21063 1.61521L8.2112 1.61475C9.09675 0.903526 10.5404 0.905341 11.4444 1.62525C11.4446 1.62541 11.4448 1.62556 11.445 1.62571L17.4451 6.42577C17.7427 6.66933 18.0155 7.06474 18.1945 7.53333C18.3733 8.00134 18.4343 8.47857 18.3768 8.85916L17.2235 15.7608C17.2233 15.7616 17.2232 15.7623 17.2231 15.763C17.0178 16.9382 15.8598 17.9167 14.6807 17.9167H4.96406C3.76484 17.9167 2.63619 16.9639 2.43102 15.773C2.43093 15.7725 2.43084 15.772 2.43076 15.7715L1.27631 8.86304L1.27601 8.86133C1.21113 8.47851 1.26777 8.00107 1.44588 7.534C1.62396 7.067 1.89984 6.67236 2.20516 6.42876L2.20646 6.42771L8.21063 1.61521ZM9.82239 16.4375C10.6124 16.4375 11.2599 15.79 11.2599 15V12.25C11.2599 11.46 10.6124 10.8125 9.82239 10.8125C9.03235 10.8125 8.38489 11.46 8.38489 12.25V15C8.38489 15.79 9.03235 16.4375 9.82239 16.4375Z",
    stroke: "#596780",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.f82ae2bd114397379a2e9c1c4723b131.svg";
export { ForwardRef as ReactComponent };